module.exports = __webpack_public_path__ + "static/media/logo-icon.d28cdbbf.png";